<div class="modal-container free-entry-modal box-shadow-card d-flex flex-column">
  <div class="modal-header bg-header border-0" mat-dialog-header>
    <div class="my-0 mx-auto p-0 pt-3 font-14 text-dark text-start" mat-dialog-title>
      <span class="d-block">{{ message | translate }}</span>
    </div>
  </div>

  <div class="modal-footer w-100 d-flex justify-content-center gap-4 border-0 mt-2 p-0 pb-4" mat-dialog-actions>
    <app-button btnLabel="ACTIONS.CONFIRM" btnClass="px-5" color="warn" mat-dialog-close />
  </div>
</div>
